import React, { useState, useEffect } from "react";
import Immutable from "immutable";
import UserActions from "../../actions/UserActions";
import AppConstants from "../../constants/AppConstants";
import FontsPanel from "./DesignSettingsFont";
import DesignSettingsStyle from "./DesignSettingsStyle";
import DesignSettingsButtons from "./DesignSettingsButtons";
import DesignSettingsBrandColors from "./DesignSettingsBrandColors";
import DesignSettingsFormFields from "./DesignSettingsFormFields";
import styles from "./DesignSettings.module.css";

const {
  THEME_TAB_STYLE,
  THEME_TAB_FONTS,
  THEME_TAB_BUTTONS,
  THEME_TAB_BRAND_COLORS,
  THEME_TAB_FORM_FIELDS,
} = AppConstants;

const DesignSettingsPanel = ({ newTheme, setNewTheme, designContext, activeTab, preview }) => {
  const [panelRef, setPanelRef] = useState();
  const [panelHeight, setPanelHeight] = useState();

  useEffect(() => {
    const updateHeight = () => panelRef && setPanelHeight(panelRef.clientHeight);
    updateHeight();
    window.addEventListener("resize", updateHeight);
    return () => window.removeEventListener("resize", updateHeight);
  }, [panelRef]);

  const _addFont = (fonts, fontName) => {
    const fontsToAdd = Array.isArray(fonts) ? fonts : [fonts];

    let newThemeFonts = newTheme.get("fonts", Immutable.Map());
    fontsToAdd.forEach((font) => {
      newThemeFonts = newThemeFonts.set(font.get("name"), font);
    });
    setNewTheme(newTheme.set("fonts", newThemeFonts));
    UserActions.trackEvent({
      event: "font-add",
      meta: {
        fontName,
        fontType: fontsToAdd[0].get("type"),
        fontStyle: fontsToAdd[0].get("style"),
        fontFamily: fontsToAdd[0].get("family"),
        fontWeight: fontsToAdd[0].get("weight"),
      },
    });
  };

  const _removeFont = (fontName) => {
    setNewTheme(newTheme.deleteIn(["fonts", fontName]));
  };

  return (
    <div
      className={`${styles["site-theme-panel"]} theme-panel`}
      id="site-theme-panel"
      data-testid="site-theme-panel"
      ref={setPanelRef}
    >
      <div className={styles["site-theme-panel-inner"]}>
        {activeTab === THEME_TAB_BRAND_COLORS ? (
          <DesignSettingsBrandColors
            preview={preview}
            theme={newTheme}
            setTheme={setNewTheme}
            designContext={designContext}
            panelHeight={panelHeight}
          />
        ) : activeTab === THEME_TAB_STYLE ? (
          <DesignSettingsStyle
            theme={newTheme}
            designContext={designContext}
            setTheme={setNewTheme}
          />
        ) : activeTab === THEME_TAB_BUTTONS ? (
          <DesignSettingsButtons
            theme={newTheme}
            setTheme={setNewTheme}
            designContext={designContext}
            panelHeight={panelHeight}
          />
        ) : activeTab === THEME_TAB_FORM_FIELDS ? (
          <DesignSettingsFormFields
            theme={newTheme}
            setTheme={setNewTheme}
            panelHeight={panelHeight}
            designContext={designContext}
          />
        ) : activeTab === THEME_TAB_FONTS ? (
          <FontsPanel
            theme={newTheme}
            addFont={_addFont}
            removeFont={_removeFont}
            designContext={designContext}
          />
        ) : (
          <FontsPanel
            theme={newTheme}
            addFont={_addFont}
            removeFont={_removeFont}
            designContext={designContext}
          />
        )}
      </div>
    </div>
  );
};

export default DesignSettingsPanel;
